import { useEffect } from 'react';

const useSublineColor = (
  topRef: React.RefObject<HTMLElement>,
  setSublineColor: (color: string) => void,
  dependency?: unknown
) => {
  useEffect(() => {
    const topEl = topRef.current;
    if (!topEl) return;

    const parent = topEl.parentElement;
    const sibling = parent?.nextElementSibling as HTMLElement | null;

    if (!sibling) return;

    const allNested = sibling.querySelectorAll<HTMLElement>('*');
    let tallestWithBg: HTMLElement | null = null;
    let maxHeight = 0;

    allNested.forEach((el) => {
      const bg = getComputedStyle(el).backgroundColor;
      const hasBg = bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)';
      const height = el.offsetHeight;

      if (hasBg && height > 100 && height > maxHeight) {
        tallestWithBg = el;
        maxHeight = height;
      }
    });

    if (tallestWithBg) {
      const bgColor = getComputedStyle(tallestWithBg).backgroundColor;
      setSublineColor(bgColor);
    } else {
      setSublineColor('#ffffff');
    }
  }, [topRef, setSublineColor, dependency]);
};

export default useSublineColor;
